import { combineReducers, type AnyAction } from 'redux';

import { login } from './login.reducer';
import { user } from './user.reducer';
import activeQuestionnaires from './activeQuestionnaires.reducer';
import { ReducerHelpers } from '../../helpers/ReducerHelpers';
import AuthConstants, { LOGOUT } from '../../constants/actions/auth.constants';

const loading = (state: string | null | undefined, action: AnyAction) =>
    ReducerHelpers.loading(state, action, [
        AuthConstants.REQUEST_RESET_PASSWORD,
        AuthConstants.RESET_PASSWORD,
    ]);

const resetPasswordSuccess = (state = false, action) => {
    switch (action.type) {
        case AuthConstants.RESET_PASSWORD:
        case AuthConstants.REQUEST_RESET_PASSWORD:
        case AuthConstants.RESET_PASSWORD_FAIL:
            return false;
        case AuthConstants.RESET_PASSWORD_SUCCESS:
            return true;
        case LOGOUT:
            return false;
        default:
            return state;
    }
};
const tokenLogin = (state: string | null | undefined, action: AnyAction) =>
    ReducerHelpers.loading(state, action, AuthConstants.LOGIN_WITH_TOKEN);

const auth = combineReducers({
    login,
    user,
    activeQuestionnaires,
    loading,
    resetPasswordSuccess,
    tokenLogin,
});
export default auth;
